module.exports = __webpack_public_path__ + "img/pin-pairing-logo.69ce4a75.svg";